import React, {FC, useEffect, useRef} from 'react';
import {useLocalStorage} from "src/core/local-storage/hooks/useLocalStorage";
import Modal from "src/components/Modal/Modal";
import {delayFor} from "src/utils/promise";

import styles from "./customer-insights-modal.module.scss";
import cx from "classnames";

interface ICustomerInsightsModalProps {

}

/* eslint-disable object-curly-newline */
const CustomerInsightsModal: FC<ICustomerInsightsModalProps> = () => {
    const [
        {waiting, opened, detached},
        setState,
    ] = useLocalStorage("customer-insights-modal", { opened: false, waiting: false, detached: false });

    const setOpened = () => setState(s => ({ ...s, opened: true, waiting: false }));
    const setWaiting = () => setState(state => ({ ...state, waiting: true }));
    const setClosed = async () => {
        setState(s => ({ ...s, opened: false }));
        await delayFor(300);
        setState(s => ({ ...s, detached: true }));
    };

    const awaitOpening = async () => {
        setWaiting();
        await delayFor(30000);
        setOpened();
    };

    useEffect(() => {
        if (opened || waiting || detached) {
            return;
        }

        awaitOpening();

        return () => setState(state => ({ ...state, waiting: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (detached) {
        return null;
    }

    return (
        <Modal
            header={(
            <h3 className={styles.header}>
                Join Our <span className={cx(styles.header, styles.headerPink)}>Exclusive €75</span> Survey!
            </h3>
            )}
            isOpen={opened}
            onClose={setClosed}
            className={styles.body}
            modalClassName={styles.modal}
        >
            <div className={styles.description}>
                <p>
                    We value your feedback! <strong>Participate in our survey and earn a €75 Amazon gift card.</strong>
                </p>
                <p>
                    Your insights are crucial in helping us enhance your gaming experience.
                    Survey open for a limited time only, so don’t miss out!
                </p>
            </div>
            <a
                className={styles.linkButton}
                href="https://adhoc.recollective.com/peer-game-study/join?key=uOQ7"
                target="_blank"
                rel="noreferrer noopener"
                onClick={setClosed}
            >
                Participate now
            </a>
        </Modal>
    );
};

export default CustomerInsightsModal;
